/**
 * 売り場
 */
export class SellArea {

  /** . */
  MediumType = '';

  /** 売り場コード. */
  SellAreaCode = '';

  /** 売り場名. */
  SellAreaName = '';

  /** . */
  UnityPrefectureDiv = '';

  /** 売り場コード名. */
  SellAreaCodeName = '';
}
